import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import Notification from "../Notification/Notification";
import { useResync } from "../../hooks/useRealtime";

/**
 * Tells the user when a change was rejected because the data had already been
 * changed on another device. The latest data is reloaded automatically.
 */
function SyncConflictNotice() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useResync((reason) => {
    if (reason === "conflict") setIsVisible(true);
  });

  const handleClose = useCallback(() => setIsVisible(false), []);

  if (!isVisible) return null;

  return (
    <Notification
      type="warning"
      duration={8000}
      message={t("sync.conflict")}
      onClose={handleClose}
    />
  );
}

export default SyncConflictNotice;
